import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { filterActions } from '../Filter/reducer';
import { selectFilters } from '../Filter/selectors';
import { getColumns } from './Document.columns';
import {
  TableHeader,
  TableHeaderCell,
  TableRow,
} from '@storebrand-digital/pretzel';
import { useDocumentContext } from './context';

function DocumentTableHead() {
  const dispatch = useDispatch();
  const activeFilters = useSelector(selectFilters);
  const { selectedSegmentId } = useDocumentContext();
  const columns = getColumns(selectedSegmentId);

  function handleSort(column: (typeof columns)[number]) {
    return column.sortable
      ? () => dispatch(filterActions.changeSortBy(column.name))
      : undefined;
  }

  return (
    <>
      <colgroup>
        {columns.map((column) => (
          <col key={`col-${column.className}`} className={column.className} />
        ))}
      </colgroup>
      <TableHeader>
        <TableRow>
          {columns.map((column) => {
            const sortDirection =
              activeFilters?.sortBy === column.name
                ? activeFilters.sortDirection
                : undefined;

            return (
              <TableHeaderCell
                scope="col"
                key={`column-${column.className}`}
                column={column.name}
                className={column.className}
                onClick={handleSort(column)}
                align={column.align}
                sortDirection={
                  sortDirection === 'DESC'
                    ? 'desc'
                    : sortDirection === 'ASC'
                      ? 'asc'
                      : undefined
                }
              >
                {column.label()}
              </TableHeaderCell>
            );
          })}
        </TableRow>
      </TableHeader>
    </>
  );
}

export default DocumentTableHead;
